import { createSlice } from '@reduxjs/toolkit'
import { isValidJSON } from '../../ui/components/common/reviewComponents/reviewUtils';
import { getAxios, getRRAxios } from './axiosActions';
import moment from 'moment';
import { handleExportExcel } from '../../common/utils';
import _ from 'lodash';
export const JSONParseDeep=(data)=>{
    const dataClone=[...data??[]]
    if(dataClone.length===0) return [];
    const keys=Object.keys(dataClone[0]);
    keys.forEach(key=>{
        if(typeof dataClone[0][key]==='string' && isValidJSON(dataClone[0][key])){
            dataClone.forEach((item)=>{
                item[key]=JSON.parse(item[key]);
            })
        }})  
        return dataClone;

}
const initialState = {
    loading: false,
    error: false,
    intercomData: []
}

const intercom = createSlice({
    name: 'intercom',
    initialState,
    reducers: {
        loadingInterComData: (state) => {
            state.loading = true
            state.error = false

        },
        interComDataSuccess: (state, { payload }) => {
            state.loading = false
            state.intercomData = isValidJSON(payload) ? JSON.parse(payload) : []
            state.error = false
        },
        loadIntercomChatSuccess: (state, { payload }) => {
            state.loading = false
            state.intercomData = payload??[]
            state.error = false
        },
        interComDataFailure: (state) => {
            state.loading = false
            state.error = true
        },
    }
});

export const { loadingInterComData, interComDataSuccess, interComDataFailure, loadIntercomChatSuccess } = intercom.actions
export const intercomSelector = (state) => state.intercom

export default intercom.reducer
export function triggerInterComDataFetch(data) {
    return async (dispatch) => {
        dispatch(loadingInterComData());
        try {
            const params = { callTime: new Date() }
            const url = `api/Intercom/GetIntercomData?startDate=${data.startDate}&endDate=${data.endDate}`;
            const response = await getAxios(
                url,
                { params: params }
            );
            if ((response?.length>0)) {
                const element = document.createElement("a");
                const textFile = new Blob([JSON.stringify(response, null, 2)], { type: 'application/json' });
                element.href = URL.createObjectURL(textFile);
                element.download = `Conversations_${moment(data.startDate).format('YYYYMMDD')}-${moment(data.endDate).format('YYYYMMDD')}.json`;
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                URL.revokeObjectURL(element.href);
                dispatch(interComDataSuccess(response));
            }
            else {
                dispatch(interComDataFailure());
            }
            // dispatch(interComDataSuccess(response));
        } catch (error) {
            dispatch(interComDataFailure());
        }
    }
}
export function exportInterComData(data,key='output') {
    return async (dispatch) => {
        dispatch(loadingInterComData());
        try {
            const params = { callTime: new Date() }
            const url = `api/Intercom/ExportIntercommData?startDate=${data.startDate}&endDate=${data.endDate}`;
            const response = await getAxios(
                url,
                { params: params }
            );
            if ((response?.length>0)) {
                const element = document.createElement("a");
                const freedData = JSONParseDeep(response);
                const {input,...rest}=freedData
                const data1=_.map(rest,(v,k)=>{const {output,...rest2}=v;return output})
                let excelData=[];
 freedData.forEach(item=>{
                    const {output}=item    
                        const {custom_attributes,...rest}=output;
                        const processedData = {...rest??{},...custom_attributes};
                        Object.keys(processedData).forEach(key => {
                            const value = processedData[key];
                            if (typeof value === 'number' && Math.abs(value) >= 1e10) {
                                processedData[key] = `="${value}"`;
                            }
                        });
                        
                        excelData.push(processedData);
                })
                //handleExportExcel(excelData,_.map(_.keys(excelData[0]),it=>({header:_.startCase(it),key:it})),`Exported_Conversations_`,true,"Converstation Output")
                const textFile = new Blob([JSON.stringify(data1, null, 2)], { type: 'application/json' });
                element.href = URL.createObjectURL(textFile);
                element.download = `chat_analysis_${moment(data.startDate).format('YYYYMMDD')}-${moment(data.endDate).format('YYYYMMDD')}.json`;
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                URL.revokeObjectURL(element.href);
            }
            else window.alert("No data available for the selected date range.");
             dispatch(interComDataSuccess(response));
        } catch (error) {
            dispatch(interComDataFailure());
        }
    }
}

export function loadDatafromDB(data) {
    return async (dispatch) => {
        dispatch(loadingInterComData());
        try {
            const params = { callTime: new Date() }
            
            const url = `api/Intercom/ExportIntercommData?startDate=${data.startDate}&endDate=${data.endDate}`;
            const response = await getAxios(
                url,
                { params: params }
            );
            
            if ((response?.length>0)) {
                const finalData=_.map(response,it=>JSON.parse(it.input??'{}'))
                dispatch(loadIntercomChatSuccess(finalData));
            }
            else {
                dispatch(interComDataFailure());
            }
            // dispatch(interComDataSuccess(response));
        } catch (error) {
            dispatch(interComDataFailure());
        }
    }
}